import { ITrack } from '@/data/models/track';
import { IValidationResults } from '@/data/models/validation';
import { IAlbum } from '@/data/models/album';
import { isEmpty, isNil } from 'lodash';
import React from 'react';
import { IMultipleTrackEdit } from '@/types/multiple-track-types';
import SingleTrackEdit from '@/components/partials/ProductTabs/TrackEditView/SingleTrackEdit/SingleTrackEdit';
import MultipleTrackEdit from '@/components/partials/ProductTabs/TrackEditView/MultipleTrackEdit/MultipleTrackEdit';
import { IChangeRequest } from '@/data/models/changeRequest';
import { ICurrentTracksChangesGroup } from '@/types/product-current-changes-types';

interface Props {
  togglePopUp: any;
  trackObj: ITrack;
  reloadTracks: any;
  errorFlag?: boolean;
  errors?: IValidationResults[];
  readonly?: boolean;
  disabled?: boolean;
  catalogUpc?: string | null;
  usesSides?: boolean;
  loadPreviousTrack?: () => void;
  loadNextTrack?: () => void;
  multipleTracksEdit?: IMultipleTrackEdit;
  album?: IAlbum;
  onSaveSuccess?: () => void;
  changeRequest?: IChangeRequest | undefined;
  currentChanges?: ICurrentTracksChangesGroup;
}

const TrackEditView = (props: Props) => {
  if (!isNil(props.multipleTracksEdit) && !isEmpty(props.multipleTracksEdit)) {
    return <MultipleTrackEdit {...props} />;
  }
  return <SingleTrackEdit {...props} />;
};

export default TrackEditView;
